import { useMemo } from 'react';
import { useSubscription } from 'urql';
import { CallErrorSummarySubscription } from './call-graphql';

export type CallErrorSummary = { severity: 'fatal' | 'degraded'; count: number };

export function useCallErrorSummary(organizationId: string | null, callControlIds: string[]) {
  const ids = useMemo(() => [...new Set(callControlIds)].sort(), [callControlIds]);

  const [{ data }] = useSubscription({
    query: CallErrorSummarySubscription,
    variables: { organizationId: organizationId ?? '', callControlIds: ids },
    pause: !organizationId || ids.length === 0,
  });

  return useMemo(() => {
    const summary = new Map<string, CallErrorSummary>();

    for (const error of data?.callErrors ?? []) {
      const existing = summary.get(error.callControlId);

      summary.set(error.callControlId, {
        severity: error.severity === 'fatal' || existing?.severity === 'fatal' ? 'fatal' : 'degraded',
        count: (existing?.count ?? 0) + 1,
      });
    }

    return summary;
  }, [data]);
}
